import { createContext } from 'react';

const RadioContext = createContext({
    name: '',
    value: '',
    readonlyGroup: undefined,
    onChange: () => { },
    autofocus: false,
});

export { RadioContext };
//# sourceMappingURL=radio-context.js.map
